import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect, ConnectedProps } from 'react-redux';
import Text from '../../atoms/Text';
import Image from '../../atoms/ImageView';
import { Feature, Variant } from '../ABFeature';
import { getSisFlag } from '../../selectors/metaData';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import properties from '../../../modules/ajio-util/properties';
import { getAppInstallFlag, getAppConfig } from '../../selectors/featureFlagsSelector';
import { triggerApp, isMicroApp } from './utils';
import useAppInstall from './useAppInstall';

import styles from './appinstall.module.pcss';

const cx = classNames.bind(styles);
const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img/appLinkIcon.svg`;

const mapStateToProps = (state: import('../../types/rootState').RootState) => ({
  appInstallFeature: getAppInstallFlag(state),
  appConfig: getAppConfig(state),
  sisFlag: getSisFlag(state)
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const OfferBanner = ({
  id = '',
  pagetype = '',
  appInstallFeature = {},
  appConfig,
  sisFlag,
  fromFleek=false
}: PropsFromRedux): Element.JSX => {
  const isAppInstall = useAppInstall();
  const { offerBanner = {} } = appInstallFeature;
  const { text } = offerBanner;
  const doNotRender = appInstallFeature[pagetype] !== 'ON' || sisFlag || isMicroApp();
  useEffect(() => {
    if (!doNotRender) {
      gtmEventPush({
        event: 'app_install_widget_impression',
        category: 'widget interaction',
        action: 'app install widget impresssion',
        label: pagetype
      });
    }
  }, []);
  if (doNotRender) {
    return null;
  }
  return (
    <Feature featureName="appInstall">
      <Variant id="0">
        {text ? (
          <div className={cx('oneLiner')} id={id}>
            <Text variant="T2" color={fromFleek ? "White": "Nero"}>{text}</Text>
            <span onClick={() => triggerApp(appConfig, pagetype, 'widget')} role="presentation">
              <Text variant="T2" weight="bold" color={fromFleek ? "White":"Pelorous"}>
                {isAppInstall ? '  Use App now' : '  Get App now'}
              </Text>
              <span className={cx('link-icon')}>
                <Image src={imgPath} alt="App install icon" />
              </span>
            </span>
          </div>
        ) : null}
      </Variant>
      <Variant id="1">{null}</Variant>
    </Feature>
  );
};

export default connector(OfferBanner);
